import {Component, Inject, OnInit} from '@angular/core';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {AppConstants} from '../../shared/constants/app-constants';
import {AccessAccountAction} from './access-account-action';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {UserAccountModel} from '../../data/model/UserAccountModel/user_account.model';
import {SelectModel} from '../../data/model/SelectModel/select.model';

@Component({
    selector: 'app-access-account-dialog',
    templateUrl: './access-account-dialog.component.html',
    styleUrls: ['./access-account-dialog.component.css'],
    standalone: false
})
export class AccessAccountDialogComponent extends AccessAccountAction implements OnInit {
  accountlist: ApiResponseModel<UserAccountModel>;
  selectList: SelectModel[] = [];
  patchBody = [];
  keys1: string[];
  errorMsg: string;
  topErrorMessage: string;
  searchText: string;
  errMsg: string;

  constructor(dataManager: DataManagerService,
              public dialogRef: MatDialogRef<AccessAccountDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    console.log(data);
    this.dataManager = dataManager;
    this._getRoleList = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_ACCOUNT + '?limit=100&page=1';
    this.getAccountList();
    this.accountlist = new ApiResponseModel();
    this._assignRoleUrl = AppConstants.BASE_URL + '/users/' + data.user_id + '/attach';
  }

  ngOnInit() {
  }

  protected passResponse(res) {
    console.log(res);
    this.accountlist = res;
    this.selectList = res.data;
    if (this.data.account_access.length > 0) {
      this.data.account_access.forEach(obj => {
        const match = this.selectList.find(x => x.id === obj.id);
        if (match) {
          match.selected = true;
        }
      });
    }


  }

  protected passError(err) {
    console.log(err);
  }

  protected passAssignResponse(res) {
    console.log(res);
    this.loadFlag = false;
    this.dialogRef.close(true);
  }

  protected passAssignError(err) {
    this.loadFlag = false;
    this.errMsg = err.message;
    this.topErrorMessage = err.errors;
    this.keys1 = Object.values(this.topErrorMessage);
  }

  /**
   * func to handle selected
   * option
   * @param $event
   */
  selectAll(select) {
    console.log(select);
    this.selectList.map( x => x.selected = select);
  }

  /**
   * func to handle reuest data
   * for assign roles request
   */
  setRoles() {
    this.loadFlag = true;
    const selectedList = this.selectList.filter( x => x.selected === true);
    for (const role of selectedList) {
      if (!this.patchBody.find(x => x === role.id)) {
        this.patchBody.push(role.id);
      }
    }
    console.log(this.patchBody);
    const body = {};
    body['account_ids'] = this.patchBody;
    this.assignRoleToUser(body);
  }

  isSelected() {
    return(this.selectList.findIndex(x => x.selected === true) > -1);
  }

  /**
   * func to close dialog
   */
  closeDialog() {
    this.dialogRef.close(false);
  }
}
